"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findNum3 = exports.findAlpha3 = exports.findAlpha2 = exports.findCountry = exports.getAllAlpha3 = exports.getAllAlpha2 = exports.getAllCountryNames = exports.getAllCountries = void 0;
const countries_1 = __importDefault(require("./countries"));
var OutputType;
(function (OutputType) {
    OutputType["CountryObject"] = "obj";
    OutputType["CountryName"] = "name";
    OutputType["Alpha2"] = "alpha2";
    OutputType["Alpha3"] = "alpha3";
    OutputType["Num3"] = "num3";
})(OutputType || (OutputType = {}));
/**
 * Get all countries
 *
 * @returns {Array<Country>}
 */
const getAllCountries = () => countries_1.default;
exports.getAllCountries = getAllCountries;
/**
 * Get all Country Names
 *
 * @returns {Array<String>}
 */
const getAllCountryNames = () => countries_1.default.map((c) => c.country);
exports.getAllCountryNames = getAllCountryNames;
/**
 * Get all Alpha2 Codes
 *
 * @returns {Array<String>}
 */
const getAllAlpha2 = () => countries_1.default.map((c) => c.alpha2);
exports.getAllAlpha2 = getAllAlpha2;
/**
 * Get all Alpha3 Codes
 *
 * @returns {Array<String>}
 */
const getAllAlpha3 = () => countries_1.default.map((c) => c.alpha3);
exports.getAllAlpha3 = getAllAlpha3;
/**
 * Find country details by country name
 *
 * @param {string} name
 * @param {OutputType} optype
 * @returns {Country | undefined}
 */
const findCountry = (name, optype = OutputType.CountryObject) => {
    let c = countries_1.default.find((country) => country.country.toUpperCase() === name.toUpperCase());
    switch (optype) {
        case OutputType.CountryObject:
            return c;
        case OutputType.Alpha2:
            return c === null || c === void 0 ? void 0 : c.alpha2;
        case OutputType.Alpha3:
            return c === null || c === void 0 ? void 0 : c.alpha3;
        case OutputType.Num3:
            return c === null || c === void 0 ? void 0 : c.num3;
        default:
            throw new Error(`Non-existent output type supplied: ${optype}`);
    }
};
exports.findCountry = findCountry;
/**
 * Find country details by ISO 3166-1 Alpha-2 Code
 *
 * @param {string} alpha2
 * @param {OutputType} optype
 * @returns {Country | undefined}
 */
const findAlpha2 = (alpha2, optype = OutputType.CountryObject) => {
    let c = countries_1.default.find((country) => country.alpha2 === alpha2.toUpperCase());
    switch (optype) {
        case OutputType.CountryObject:
            return c;
        case OutputType.CountryName:
            return c === null || c === void 0 ? void 0 : c.country;
        case OutputType.Alpha3:
            return c === null || c === void 0 ? void 0 : c.alpha3;
        case OutputType.Num3:
            return c === null || c === void 0 ? void 0 : c.num3;
        default:
            throw new Error(`Non-existent output type supplied: ${optype}`);
    }
};
exports.findAlpha2 = findAlpha2;
/**
 * Find country details by ISO 3166-1 Alpha-3 Code
 *
 * @param {string} alpha3
 * @param {OutputType} optype
 * @returns {Country | undefined}
 */
const findAlpha3 = (alpha3, optype = OutputType.CountryObject) => {
    let c = countries_1.default.find((country) => country.alpha3 === alpha3.toUpperCase());
    switch (optype) {
        case OutputType.CountryObject:
            return c;
        case OutputType.CountryName:
            return c === null || c === void 0 ? void 0 : c.country;
        case OutputType.Alpha2:
            return c === null || c === void 0 ? void 0 : c.alpha2;
        case OutputType.Num3:
            return c === null || c === void 0 ? void 0 : c.num3;
        default:
            throw new Error(`Non-existent output type supplied: ${optype}`);
    }
};
exports.findAlpha3 = findAlpha3;
/**
 * Find country details by ISO 3166-1 Numeric Num-3 Code
 *
 * @param {string | number} num3
 * @param {OutputType} optype
 * @returns {Country | undefined}
 */
const findNum3 = (num3, optype = OutputType.CountryObject) => {
    let c = countries_1.default.find((country) => country.num3 === String(num3));
    switch (optype) {
        case OutputType.CountryObject:
            return c;
        case OutputType.CountryName:
            return c === null || c === void 0 ? void 0 : c.country;
        case OutputType.Alpha2:
            return c === null || c === void 0 ? void 0 : c.alpha2;
        case OutputType.Alpha3:
            return c === null || c === void 0 ? void 0 : c.alpha3;
        default:
            throw new Error(`Non-existent output type supplied: ${optype}`);
    }
};
exports.findNum3 = findNum3;
exports.default = {
    getAllCountries: exports.getAllCountries,
    getAllCountryNames: exports.getAllCountryNames,
    getAllAlpha2: exports.getAllAlpha2,
    getAllAlpha3: exports.getAllAlpha3,
    findCountry: exports.findCountry,
    findAlpha2: exports.findAlpha2,
    findAlpha3: exports.findAlpha3,
    findNum3: exports.findNum3,
};
